// export class CPPOrderSummaryVM {
//  product: string
//  pricingUOM: string
//  pricingPerUnitPricingUOM: number
//  package: string
//  orderUOM: string
//  pricePerUnitOrderUOM: number
// }

export class CPPOrderSummaryVM {
  emailAddress: string;
  primaryPhoneNumber: string;
  webOrderNumber: string;
  splitId: number;
  placedBy: string;
  placedByName: string;
  createdOn?: Date;
  accountAddress1: string;
  accountAddress2: string;
  accountNumber: string;
  accountName: string;
  accountCity: string;
  accountState: string;
  accountZipCode: string;
  asc: string;
  orderStatus: string;
  // productDetail: CPPOrderSummaryItemList[]
  product: string;
  pricingUOM: string;
  pricingPerUnitPricingUOM: number;
  package: string;
  orderUOM: string;
  orderType: string;
  pricePerUnitOrderUOM: number;
  cppOrderId: number;
  headerText: string;
  instructionType: string;
  customerPickUp: string;
  custPONumber: string;
  bulkContactName: string;
  bulkContactNumber: string;
  contactEmailAddress: string;
  jdeorderNumber: string;
  isAvailableInOTIHeader: boolean;
  desiredDeliveryDate?: Date;
  splitDetails: CPPOrderSplitDetails[];
  ascDetail: CPPAscDetail;
  dsmDetail: CPPDSMDetail;
  deliverToDetail: CPPDeliverToDetail;
  soldToDetail: CPPSoldToDetail;
  yourPrice: number;
  paymentTerms: string;
  specialInstructionText: string;
}
export class CPPAscDetail {
  ascName: string;
  ascAddress1: string;
  ascAddress2: string;
  city: string;
  state: string;
  zipCode: string;
  primaryPhone: string;
  emailAddress: string;
}
export class CPPDSMDetail {
  dsmAccountName: string;
  dsmAddress1: string;
  city: string;
  state: string;
  zipCode: string;
  primaryPhone: string;
  emailAddress: string;
}

export class CPPDeliverToDetail {
  accountNo: string;
  accountName: string;
  address1: string;
  city: string;
  state: string;
  zipCode: string;
}

export class CPPSoldToDetail {
  accountNo: string;
  accountName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  repackAgreement: string;
}

export class CPPOrderSummaryItemList {
  itemId: number;
  itemNumber: string;
  itemDescription: string;
  itemVendorName: string;
  isRepackItem: string;
  repackAgreement: string;
  packageSize: string;
  gtin: string;
  actveIngredient: string;  // Need to be send as comma seperated string
  productSegment: string;
  productLine: string;
  palletQuantity?: number;
  programName: string;
  bulkPackaged: string;
  vendedProprietary: string;
  xrefCheckBK: string;
  itemFlashMsg: string;
  restrictedUse: string;
  returnable: string;
  uom: string;
  price?: number;
  pricePerUnit?: number;
  priceCurrency: string;
  pricingUnitOfMeasure: string;
  pricingPackageSize: string;
  isFavorite: boolean;
  desiredDelDate?: Date;
  orderUOM: string;
  webStandardUOM: string;
  webStandardOrderUOM: string;
  pricingUnitConvFactor?: number;
  orderConvFactor?: number;
  productName: string;
  vendorName: string;
  pricingUOM: string;
  pricePerOrderUnit: number;
  originalOrderQuantity: number;
  totalPrice: number;
}

export class CPPOrderSplitDetails {
  splitId: number;
  orderStatus: string;
  productDetail: CPPOrderSummaryItemList[];
}
